<template>
  <div>
    <header>
      <router-view name="nav" />
    </header>
    <b-container fluid style="margin-bottom:35px!important;">
      <router-view name="body" style="margin-bottom:150px;" />
    </b-container>
    <br />
    <br />
    <b-row class="mt-5 footer" v-if="true">
      <!-- <b-navbar>
        <b-navbar-nav justified fill> -->
      <b-row>
        <b-col class="d-flex">
          <b-col :cols="9" class="d-flex text-middle text-center">
            <span class="ml-4 fine-print">
              &copy; 2020 LINK Document Services Group LLC. All rights reserved.
            </span>
          </b-col>
          <b-col :cols="3" class="d-flex justify-content-end fine-print">
            <b-link href="http://www.linkdsg.com/terms-of-use" target="_blank">
              Terms of Use
            </b-link>
            <i class="ml-1 mr-1">|</i>
            <b-link
              href="http://www.linkdsg.com/privacy-policy"
              target="_blank"
            >
              Privacy Policy
            </b-link>
          </b-col>
        </b-col>
      </b-row>
      <!-- </b-navbar-nav>
      </b-navbar> -->
    </b-row>
  </div>
</template>

<script>
export default {
  name: "App"
};
</script>

<style>
html {
  height: 100% !important;
}

/* header {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 55px;
  justify-items: center;
  background-color: #013354 !important;
} */

header img {
  width: 200px;
  left: 0;
  margin: 10px;
  overflow: hidden;
}

#bdy {
  margin-top: 50px;
}
.fine-print {
  font-size: 12px !important;
}
</style>



// WEBPACK FOOTER //
// src/App.vue